var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.accessoryFeatures.title))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row", attrs: { id: "anchor-technical-sheet" } },
      _vm._l(
        _vm.accessoryFeatures.technicalFeatures,
        function (feature, index) {
          return _c(
            "div",
            {
              key: "technical-feature-" + index,
              staticClass: "mb-2 mb-md-3",
              class: index === 0 ? "col-12" : "col-12 col-md-6",
            },
            [
              _c("p", { staticClass: "lead fw-bold mb-0" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(feature.title) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "text-mw standard",
                domProps: { innerHTML: _vm._s(feature.text) },
              }),
            ]
          )
        }
      ),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }